<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Audra List</h1>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>

            <div class="card-tools" v-if="1 == 0">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i> Export
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!--  User ID/MAC -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="activation_email"
                      >User ID/MAC</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="activation_email"
                          name="activation_email"
                          v-model="filter.activation_email"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="User ID/MAC"
                        />
                      </div>
                    </div>
                  </div>

                  <!--  User Name -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="device_name"
                      >User Name</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="device_name"
                          name="device_name"
                          v-model="filter.device_name"
                          :class="{
                            'has-error': errors.has('device_name'),
                          }"
                          class="form-control"
                          placeholder="User Name"
                        />
                      </div>
                    </div>
                  </div>

                  <!--  Version -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="version">Version</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="version"
                          name="version"
                          v-model="filter.version"
                          :class="{
                            'has-error': errors.has('version'),
                          }"
                          class="form-control"
                          placeholder="Version"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row justify-content-end">
                    <div class="col-md-9">
                      <button type="submit" class="btn mr-3">
                        <i class="icon-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-outline" @click="resetFilter()">
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Username</th>
                      <th>MAC</th>
                      <th>Model</th>
                      <th>Version</th>
                      <th>Device Name</th>
                      <th>License</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td>
                        <router-link
                          :to="{
                            name: 'DeviceDetails',
                            params: { userId: val.userId, accountId: val.id },
                          }"
                        >
                          {{ val.activation_email }}
                          <i class="icon-arrow-right"></i>
                        </router-link>
                      </td>
                      <td>{{ val.AP_WI_mac }}</td>
                      <td>{{ val.device_type }}</td>
                      <td>{{ val.version }}</td>
                      <td>{{ val.device_name }}</td>

                      <!-- <td>{{ val.activation_email }}</td> -->

                      <td>{{ val.license_user }}</td>
                      <td>{{ processStatus(val) }}</td>
                      <!-- <td class="text-right">
                      <router-link v-if="actionEdit == true || checkEditPermission(val)"
                        :to="{ name: 'SNMPEdit', params: { id: val.id } }" class="btn btn-info btn-sm m-2px">
                        <i class="fas fa-pencil-alt"></i>
                      </router-link>
                      <a v-if="actionDelete == true || checkDeletePermission(val)" class="btn btn-danger btn-sm m-2px"
                        href="javascript:void(0)" @click="deleteObject(val.id, val.accountId, index)"><i
                          class="fas fa-trash"></i></a>
                    </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import { mapGetters } from "vuex";
// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";

export default {
  name: "ActivationKey",
  metaInfo: {
    title: "Audra List | Dotlines",
  },
  components: {
    VuePagination,
    SortIcons,
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: true,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {},
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/activationkeys";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;

      if (this.$route.name == "RouterList") {
        this.filter = this.$route.params;
      }

      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      await CommonAPI.getCustomPermission(
        "/get-custom-permission-infos?path=api/activationkeys"
      ).then((response) => {
        if (response.status == 200) {
          this.custom_permission_data = response.data;
        }
      });

      if (!_.isEmpty(this.custom_permission_data)) {
        this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["create_id_condition"],
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
        this.actionCreate = true;
      }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    exportFile: function () {
      this.is_loading = true;
      axios
        .get("/activationkeys-export", {
          params: { userAccountId: LocalStorage.get("accountId") },
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "activationkeys.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },
    processStatus: function (val) {
      if (!val.updated_at) return "Offline";
      if (val.pstatus == 1 || val.sstatus == 1) {
        return (
          "Online" + "(" + moment(val.updated_at).format("YYYY-MM-DD, h:mm:ss a") + ")"
        );
      } else {
        return (
          "Offline" + "(" + moment(val.updated_at).format("YYYY-MM-DD, h:mm:ss a") + ")"
        );
      }
    },
  },
  /* created() {
      this.$emit("update:layout", MasterLayout);
    }, */
};
</script>
